import React from 'react'
import { useTranslation } from 'react-i18next'
import { RequirementCardContainer } from 'components/Shared/Fields/styles'
import IconButton from 'particles/Button/IconButton'
import Field from 'components/Shared/Fields'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'
import { fieldIdentifiers } from 'components/Shared/Comment'

interface FreeInputRequirementProps {
    name: string
    onRemove: () => void
    isReadOnly?: boolean
    requirementUuid?: string
}

const FreeInputRequirement: React.FC<FreeInputRequirementProps> = ({ name, onRemove, isReadOnly, requirementUuid }) => {
    const [t] = useTranslation()

    return (
        <RequirementCardContainer isCard>
            {!isReadOnly && (
                <div className="field-close field-title">
                    <IconButton icon="x" form="icon" size="xs" color="neutral" onClick={onRemove} />
                </div>
            )}
            <CampaignEditorInputFieldContainer>
                <Field.TextAreaField
                    name={name}
                    isRequired
                    width="100%"
                    label={t('campaignEditor.requirement.freeInputHeader')}
                    identifier={`${requirementUuid}_${fieldIdentifiers.freeInput}`}
                    isReadOnly={isReadOnly}
                />
            </CampaignEditorInputFieldContainer>
        </RequirementCardContainer>
    )
}

export default FreeInputRequirement
